var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add",
    clipPath: "url(#clip0_6528_8173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9998 7.58317H8.08317V10.4998C8.08317 10.8207 7.82067 11.0832 7.49984 11.0832C7.179 11.0832 6.9165 10.8207 6.9165 10.4998V7.58317H3.99984C3.679 7.58317 3.4165 7.32067 3.4165 6.99984C3.4165 6.679 3.679 6.4165 3.99984 6.4165H6.9165V3.49984C6.9165 3.179 7.179 2.9165 7.49984 2.9165C7.82067 2.9165 8.08317 3.179 8.08317 3.49984V6.4165H10.9998C11.3207 6.4165 11.5832 6.679 11.5832 6.99984C11.5832 7.32067 11.3207 7.58317 10.9998 7.58317Z",
    fill: "#653494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6528_8173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4ff36634341a6491c63e5a0394db7deb.svg";
export { ForwardRef as ReactComponent };